import React from 'react';
import { Box, FormControl, FormHelperText, FormLabel, Grid, TextField } from '@mui/material';
import { Controller, UseFormReturn } from 'react-hook-form';
import { createScopedI18n } from '../../i18n/i18n';
import { CreateGuestJobValueType } from './page';
import FormActions from './form_actions';

interface ContactFormProps {
  form: UseFormReturn<CreateGuestJobValueType>;
  onNext: () => void;
  onPrevious: () => void;
  loading?: boolean;
}

const registerFieldI18n = createScopedI18n('graphql.fields.register');

const ContactForm: React.FC<ContactFormProps> = ({ form, onNext, onPrevious, loading }) => {
  const { control, trigger } = form;

  const handleNext = async () => {
    const isValid = await trigger(['contactEmail', 'contactPhoneNumber']);
    if (isValid) {
      onNext();
    }
  };

  const handlePrevious = () => {
    onPrevious();
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      <Controller
        key="contactEmail"
        control={control}
        name="contactEmail"
        render={({ field: { value, ...field }, fieldState: { invalid, error } }) => (
          <FormControl id={field.name} fullWidth error={invalid}>
            <Grid item container alignItems="center" gap={1}>
              <Grid item xs={3}>
                <FormLabel>{registerFieldI18n('contact_email')} *</FormLabel>
              </Grid>
              <Grid item xs>
                <TextField id={field.name} type="email" fullWidth value={value ?? ''} error={invalid} {...field} />
              </Grid>
            </Grid>
            <Grid item container gap={1}>
              <Grid item xs={3} />
              <Grid item xs>
                <FormHelperText>{error?.message}</FormHelperText>
              </Grid>
            </Grid>
          </FormControl>
        )}
      />
      <Controller
        key="contactPhoneNumber"
        control={control}
        name="contactPhoneNumber"
        render={({ field: { value, ...field }, fieldState: { invalid, error } }) => (
          <FormControl id={field.name} fullWidth error={invalid}>
            <Grid item container alignItems="center" gap={1}>
              <Grid item xs={3}>
                <FormLabel>{registerFieldI18n('contact_phone_number')} *</FormLabel>
              </Grid>
              <Grid item xs>
                <TextField id={field.name} type="tel" fullWidth value={value ?? ''} error={invalid} {...field} />
              </Grid>
            </Grid>
            <Grid item container gap={1}>
              <Grid item xs={3} />
              <Grid item xs>
                <FormHelperText>{error?.message}</FormHelperText>
              </Grid>
            </Grid>
          </FormControl>
        )}
      />

      <FormActions loading={loading} onNext={handleNext} onPrevious={handlePrevious} />
    </Box>
  );
};

export default ContactForm;
